import React, { useEffect, useRef } from 'react';
import { FiPlus, FiTrash2 } from 'react-icons/fi';
import { isEmpty } from './format';
import styles from './styles.module.css';

/* Таблица-сетка портфолио (п. 5–6 ТЗ).

   columns: [{ key, label, title?, left?, className? }] — колонки данных;
   numbered — колонка «№ п/п», номера идут подряд и пересчитываются;
   rows — массив объектов с ключами колонок.

   В просмотре незаполненная ячейка — прочерк, без строк — «Сведения не внесены».
   В правке ячейки становятся полями ввода, справа корзина, под таблицей
   «+ Добавить строку»; новая строка встаёт в конец, курсор — в её первое поле.
   Колонка корзины есть всегда: её ширина зарезервирована и в просмотре,
   чтобы таблица не прыгала при включении правки. */

const cx = (...names) => names.filter(Boolean).join(' ');

const GridTable = ({ columns, rows, numbered = false, editing = false, onChange, onAdd, onDelete }) => {
  const tableRef = useRef(null);
  const focusRow = useRef(null);

  // после добавления строки курсор ставится в её первое поле
  useEffect(() => {
    if (focusRow.current === null || !tableRef.current) return;
    const input = tableRef.current.querySelector(`tr[data-row="${focusRow.current}"] input`);
    focusRow.current = null;
    if (input) input.focus();
  }, [rows.length]);

  const handleAdd = () => {
    focusRow.current = rows.length;
    onAdd();
  };

  const colCount = columns.length + (numbered ? 1 : 0) + 1;
  const lastIndex = columns.length - 1;

  return (
    <div className={styles.tblWrap}>
      <table className={styles.tbl} ref={tableRef}>
        <thead>
          <tr>
            {numbered && <th className={styles.colNum}>№ п/п</th>}
            {columns.map((col, i) => (
              <th
                key={col.key}
                title={col.title}
                className={cx(col.className, !editing && i === lastIndex && styles.actPrev)}
              >
                {col.label}
              </th>
            ))}
            <th className={cx(styles.colAct, !editing && styles.actView)}>{editing ? 'Удалить' : ''}</th>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && (
            <tr>
              <td colSpan={colCount}>
                <div className={styles.emptyRow}>Сведения не внесены</div>
              </td>
            </tr>
          )}
          {rows.map((row, ri) => (
            <tr key={ri} data-row={ri}>
              {numbered && <td className={styles.num}>{ri + 1}</td>}
              {columns.map((col, i) => (
                <td
                  key={col.key}
                  className={cx(
                    col.left && styles.left,
                    editing && styles.cell,
                    !editing && i === lastIndex && styles.actPrev
                  )}
                >
                  {editing
                    ? (
                      <input
                        className={styles.input}
                        value={row[col.key] == null ? '' : row[col.key]}
                        onChange={(e) => onChange(ri, col.key, e.target.value)}
                        aria-label={col.label}
                      />
                    )
                    : (isEmpty(row[col.key]) ? <span className={styles.dash}>—</span> : row[col.key])}
                </td>
              ))}
              <td className={cx(!editing && styles.actView)}>
                {editing && (
                  <button type="button" className={styles.del} title="Удалить строку" onClick={() => onDelete(ri)}>
                    <FiTrash2 size={17} />
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {editing && (
        <div className={styles.addRow}>
          <button type="button" onClick={handleAdd}>
            <FiPlus size={16} />
            Добавить строку
          </button>
        </div>
      )}
    </div>
  );
};

export default GridTable;
